<template>
  <div>
    <span class="text-xs text-gray-500 uppercase leading-4 tracking-wider">{{
      title
    }}</span>
    <section class="block w-full bg-gray-100 rounded-md border border-gray-300">
      <svg ref="canvas" class="w-full"></svg>
    </section>
  </div>
</template>

<script>
// import Component from "../component_location"
// import * as d3 from "d3";

export default {
  components: {},

  props: {
    title: { default: "Property" },
    min: { type: Number, default: 0 },
    max: { type: Number, default: 10 },
    percent: { type: Boolean, default: true },
    value: Object,
    precision: { type: Number, default: 0 },
    ranged: { type: Boolean, default: true }, // start & stop handles?
    snapTo: { type: Number, default: -1 },
  },

  data() {
    return {
      width: 0,
      state: this.value,
    };
  },

  watch: {},

  methods: {
    update(state) {
      this.state = state;
      this.$emit("input", this.state);
    },
  },

  computed: {},

  mounted() {
    var self = this;
    var percent = this.percent;
    var precision = this.precision;
    var ranged = this.ranged;
    var minVal = this.min;
    var maxVal = this.max;
    var svgHeight = 60;
    var barHeight = 6;
    var handleRadius = 10;
    var paddingSize = 12;
    if (percent) {
      minVal = 0;
      maxVal = 100;
    }

    var canvas;

    var barWidth = d3
      .select(this.$refs.canvas)
      .node()
      .getBoundingClientRect().width;

    // var state = { start: 0, end: 0.5 };
    var state = this.state;

    var snap = function(num) {
      // Snap value to nearest snapTo integer (if snapTo is specified).
      if (self.snapTo > 0) {
        num = Math.round(num / self.snapTo) * self.snapTo;
      }
      return num;
    };

    var inverseSnap = function(num) {
      // Snap handle to the nearest pixel.
      var domainWidth = barWidth - 2 * paddingSize;
      if (self.snapTo > 0) {
        if (self.percent) {
          var pixelSnap = Math.round(domainWidth * self.snapTo);
          num = Math.round(num / pixelSnap) * pixelSnap;
          // However... we want to snap to the endpoints regardless.
          if (computeState({ x: num }) == 0) {
            num = paddingSize;
          }
          if (computeState({ x: num }) == 1) {
            num = barWidth - paddingSize;
          }
        } else {
          var pixelSnap = Math.round(
            domainWidth / ((self.max - self.min) / self.snapTo)
          );
          num = Math.round(num / pixelSnap) * pixelSnap;
          // However... we want to snap to the endpoints regardless.
          if (computeState({ x: num }) == self.min) {
            num = paddingSize;
          }
          if (computeState({ x: num }) == self.max) {
            num = barWidth - paddingSize;
          }
        }
      }
      return num;
    };

    var computeState = function(d) {
      var domainWidth = barWidth - 2 * paddingSize;
      var pos = d.x - paddingSize;
      let val = pos / domainWidth;
      if (!percent) {
        val = minVal + (maxVal - minVal) * val;
      }
      val = Math.max(minVal, val);
      val = Math.min(maxVal, val);
      return snap(val);
    };

    var pixelState = function(state) {
      state.start = snap(state.start);
      state.end = snap(state.end);
      var domainWidth = barWidth - 2 * paddingSize;
      if (percent) {
        var startX = paddingSize + domainWidth * state.start;
        var endX = paddingSize + domainWidth * state.end;
      } else {
        var startFrac = (state.start - minVal) / (maxVal - minVal);
        var endFrac = (state.end - minVal) / (maxVal - minVal);
        var startX = paddingSize + domainWidth * startFrac;
        var endX = paddingSize + domainWidth * endFrac;
      }
      startX = inverseSnap(startX);
      endX = inverseSnap(endX);
      if (ranged) {
        return [
          { handleType: "start", x: startX },
          { handleType: "end", x: endX },
        ];
      } else {
        return [{ handleType: "start", x: startX }];
      }
    };

    var labelText = function(d) {
      let val = computeState(d);
      var handleLabel;
      if (!ranged) {
        handleLabel = "value";
      } else {
        handleLabel = d.handleType;
      }
      if (percent) {
        val = parseInt(val * 100);
        var label = `${handleLabel} (${val.toFixed(0)}%)`;
      } else {
        var label = `${handleLabel} (${val.toFixed(precision)})`;
      }
      return label;
    };

    var labelX = function(d) {
      var labelWidth = this.getBoundingClientRect().width;
      if (
        d.x > labelWidth / 2 + 5 &&
        d.x < barWidth - paddingSize - labelWidth / 2
      ) {
        return d.x - labelWidth / 2 + 5;
      } else if (d.x < labelWidth / 2 + 5) {
        return paddingSize;
      } else {
        return barWidth - paddingSize - labelWidth + 2;
      }

      // if (d.x < barWidth - labelWidth) {
      //   return d.x - labelWidth / 2;
      // } else if  (d.x<labelWidth)  {
      //   return barWidth - this.getBoundingClientRect().width - 5;
      // }
    };

    var labelY = function(d) {
      var textHeight = this.getBoundingClientRect().height;
      if (d.handleType == "start") {
        return svgHeight / 2 - handleRadius - 2;
      } else {
        return svgHeight / 2 + textHeight + 5;
      }
    };

    var dragged = function(event, d) {
      if (event.x >= paddingSize - 2 && event.x <= barWidth - paddingSize + 2) {
        d.x = inverseSnap(event.x);
        d3.select(this)
          .raise()
          .attr("cx", d.x);

        // Update handle labels.
        canvas
          .selectAll("text.handle-labels")
          .text(labelText)
          .attr("x", labelX);
      }
    };

    var dragstop = function(event, d) {
      state[d.handleType] = computeState(d);
      self.$emit("input", state);
    };

    var dragstart = function(event, d) {
      d3.select(this.parentNode).raise();
    };

    var dragging = d3
      .drag()
      .on("start", dragstart)
      .on("drag", dragged)
      .on("end", dragstop);

    // SET UP THE SVG CANVAS
    canvas = d3.select(this.$refs.canvas).attr("height", svgHeight);

    // Handle clicks on the bar

    var moveHandle = function(event, d) {
      // canvas
      //   .select("circle.start")
      //   .transition()
      //   .duration(400)
      //   .ease(d3.easeCubic)
      //   .attr("cx", event.layerX);
    };

    // Position handles according to current state.
    var handles = pixelState(state);

    canvas
      .append("g")
      .attr("class", "slider-group")
      .append("rect")
      .attr("class", "slider-bar")
      .attr("width", barWidth - 2 * paddingSize)
      .attr("x", paddingSize)
      .attr("y", svgHeight / 2 - barHeight / 2)
      .attr("height", barHeight)
      .attr("fill", "#93C5FD")
      .on("click", moveHandle);

    // Left stop
    canvas
      .append("circle")
      .attr("cx", paddingSize)
      .attr("cy", svgHeight / 2)
      .attr("r", handleRadius * 0.6)
      .attr("fill", "#93C5FD");

    // Right stop
    canvas
      .append("circle")
      .attr("cx", barWidth - paddingSize)
      .attr("cy", svgHeight / 2)
      .attr("r", handleRadius * 0.6)
      .attr("fill", "#93C5FD");

    canvas
      .selectAll(".handles")
      .data(handles)
      .enter()
      .append("g")
      .attr("class", "handle")
      .append("circle")
      .attr("class", (d) => {
        return d.handleType;
      })
      .call(dragging)
      .attr("cx", (d) => d.x)
      .attr("cy", (d) => svgHeight / 2)
      .attr("r", handleRadius)
      .attr("fill", (d) => {
        if (d.handleType == "start") {
          return "#BFDBFE";
          return "#60A5FA";
        } else {
          return "#3B82F6";
          return "#3B82F6";
        }
      });

    // add the handles
    canvas
      .selectAll(".handle")
      .append("text")
      .text(labelText)
      .attr("class", (d) => {
        return d.handleType + "  handle-labels";
      })
      .attr("font-family", "Inter")
      .attr("x", (d) => {
        return d.x;
      })
      .attr("y", labelY)
      .attr("fill", (d) => {
        if (d.handleType == "start") {
          return "#60A5FA";
        } else {
          return "#3B82F6";
        }
      });

    // Refresh label positions once text is finished drawing (avoids issues at edges)
    var refreshPositions = function() {
      canvas.selectAll(".handle-labels").attr("x", labelX);
    };
    setTimeout(refreshPositions, 200); // wait 200 milliseconds.
  },
};
</script>

<style></style>
